import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import {
  selectMeteorologyAgroCultureIndexLocationStage,
  selectMeteorologyAgroCultureIndexLocationCulture,
  setStage as setStageRedux,
} from 'redux/reducers/meteorologyAgroCultureIndexLocationReducer';
import { store } from 'redux/store';
import { CultureIndexPhenologicalStage } from 'types/Meteorology/Agro/CultureIndex/phenologicalStage';
import usePhenologicalStage from '../usePhenologicalStage';

export default function useStages() {
  const selectedCulture = useSelector(selectMeteorologyAgroCultureIndexLocationCulture);
  const cultureLabel = selectedCulture?.label;
  const { stages } = usePhenologicalStage(cultureLabel);

  const setStage = useCallback((stage: CultureIndexPhenologicalStage | undefined) => {
    store.dispatch(setStageRedux(stage));
  }, []);

  const selectedStage = useSelector(selectMeteorologyAgroCultureIndexLocationStage);

  return {
    stages,
    selectedStage,
    setStage,
  };
}
